export default "__VITE_ASSET__CMgU4vsI__"